// Components
import { IDaysOfWeekOption } from "./Helpers";
import {
  IUser,
  IDynamicQuery,
  IQueryArguments,
  ISearchPairing,
  IPairing,
  IFlightType,
  IPosition,
  OpenFlyingStatusType,
  FlightRemovalType,
  IFilterOption,
} from "@vmosolutions/oc-interfaces";
// Airport Retrieval
import { IAirportOption } from "src/redux/reducers/StructuresReducer"; //IAirportOptionMap

// PAIRING SEARCH FILTERS
export const pairingFilterOptions: IFilterOption[] = [
  // {
  //   value: "origin",
  //   label: "Origin",
  //   type: "pairings",
  //   searchValue: null,
  // },
  // {
  //   value: "destination",
  //   label: "Destination",
  //   type: "pairings",
  //   searchValue: null,
  // },
  {
    value: "shortId",
    label: "Short Code",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "start",
    label: "Check-In",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "end",
    label: "Check-Out",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "onCrewMember",
    label: "Crew Member",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "hasSlot",
    label: "Includes Position",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "hasEmptySlots",
    label: "Empty Positions (All)",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "notOpen",
    label: "Empty & Not Open",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "hasOpenFlyingSlotsNonVisible",
    label: "Open Flying - Hidden",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "hasOpenFlyingSlotsVisible",
    label: "Open Flying - Visible",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "flightNumber",
    label: "Includes Flight #",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "positioningFlightNumber",
    label: "Includes Positioning Flight #",
    type: "pairings",
    searchValue: null,
  },

  {
    value: "aircraftType",
    label: "Aircraft Type",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "flightType",
    label: "Flight Type",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "eventType",
    label: "Ground Event Type",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "removedFlights",
    label: "Removed Flights",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "removedPosFlights",
    label: "Removed Positioning Flights",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "nonFlyingType",
    label: "Assignment Type",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "logicModifierType",
    label: "Logic Modifier",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "baseICAO",
    label: "Base",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "foreignId",
    label: "Foreign Id",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "batchId",
    label: "Batch Id",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "createdBy",
    label: "Created By",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "createdAt",
    label: "Created At",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "modifiedBy",
    label: "Modified By",
    type: "pairings",
    searchValue: null,
  },
  {
    value: "modifiedAt",
    label: "Modified At",
    type: "pairings",
    searchValue: null,
  },
];

/**
 * for content management
 * Parse the current search filter format into the accepted query format
 */
export const convertFilter2Query = (searchFilter: any): IDynamicQuery => {
  //input (Filter Search format) = { value: "f_flightNumber", label: "Flight #", type: "flightEvent", searchValue: ["908", "112"]}
  //output (IDynamicQuery format) = { field: "flightNumber", condition: "EQ", value: [908, 112] };

  // Filters are reduced so that they are only returned if they contain valid values.
  const newFilters = searchFilter.reduce((queryFilters: IQueryArguments[], filter: any) => {
    const fieldName = filter.value;
    if (!filter.searchValue) {
      return null;
    }
    const { searchValue } = filter;
    const queryObjs: IQueryArguments[] = [];

    switch (fieldName) {
      case "shortId":
        queryObjs.push({ value: searchValue, condition: "EQ", field: "shortId" });
        break;
      case "positioningFlightNumber":
        queryObjs.push({
          value: searchValue.map((flightNumber: string) => parseInt(flightNumber)),
          condition: "EQ",
          field: "eventGroups.positioningFlights.flightNumber",
        });
        break;
      case "flightNumber":
        queryObjs.push({
          value: searchValue.map((flightNumber: string) => parseInt(flightNumber)),
          condition: "EQ",
          field: "eventGroups.flights.flightNumber",
        });
        break;
      // Pairing Check-In/Check-Out
      case "start":
      case "end":
      case "createdAt":
      case "modifiedAt": {
        const from = searchValue?.minTime ? new Date(searchValue.minTime)?.valueOf() : null;
        const to = searchValue?.maxTime ? new Date(searchValue.maxTime)?.valueOf() : null;
        const timeQueryObj: IQueryArguments = { field: fieldName, condition: "EQ", value: null };
        if (!!from && !!to) {
          timeQueryObj.condition = "BT";
          timeQueryObj.value = [from, to];
        } else if (!!from && !to) {
          timeQueryObj.condition = "GT";
          timeQueryObj.value = from;
        } else {
          timeQueryObj.condition = "LT";
          timeQueryObj.value = to;
        }
        // If supplied, apply selected days in it's rrule format.
        const byDays = filter?.searchValue?.daysOfWeek;
        const rRule: string =
          Array.isArray(byDays) && byDays.length > 0
            ? `BYDAY=${byDays.map((option: IDaysOfWeekOption) => option.rrule).toString()};`
            : null;
        if (rRule) {
          timeQueryObj.rrule = rRule;
        }
        queryObjs.push(timeQueryObj);
        break;
      }
      case "flightType":
        queryObjs.push({ value: searchValue, condition: "EQ", field: "eventGroups.flights.flightType._id" });
        break;
      case "eventType":
        queryObjs.push({
          value: searchValue,
          condition: "EQ",
          field: "eventGroups.groundEvents.eventType._id",
        });
        break;
      case "removedFlights": {
        const removalTypes = searchValue.map((type: { value: FlightRemovalType; label: string }) => type.value);
        queryObjs.push({ value: removalTypes, condition: "EQ", field: "eventGroups.flights.removalType" });
        break;
      }
      case "removedPosFlights": {
        const values = searchValue.map((type: { value: FlightRemovalType; label: string }) => type.value);
        queryObjs.push({ value: values, condition: "EQ", field: "eventGroups.positioningFlights.removalType" });
        break;
      }
      case "aircraftType":
        queryObjs.push({
          value: searchValue,
          condition: "EQ",
          field: "eventGroups.flights.aircraft.aircraftType.title",
        });
        break;
      case "logicModifierType":
        queryObjs.push({ value: searchValue, condition: "EQ", field: "logicModifiers.logicModifier._id" });
        break;
      case "nonFlyingType":
        queryObjs.push({
          value: searchValue,
          condition: "EQ",
          field: "eventGroups.nonFlyingAssignments.assignmentType._id",
        });
        break;
      case "hasSlot": {
        const positionTitles = searchValue.map((pos: IPosition) => pos.title);
        queryObjs.push({ value: positionTitles, condition: "EQ", field: "positions.position" });
        break;
      }
      case "hasEmptySlots": {
        // {"field":"positions","condition":"ELEMENTMATCH","value":[{"field":"position","condition":"EQ","value":["FO"]}, //want something that looks like
        const emptyPositionTitles = searchValue.map((pos: IPosition) => pos.title);
        const subQueryValueObj = [
          {
            field: "position",
            value: emptyPositionTitles,
            condition: fieldName === "hasSlot" ? "NE" : "EQ",
          },
          {
            field: "crew_id",
            value: null,
            condition: "EQ",
          },
        ];
        queryObjs.push({ field: "positions", condition: "ELEMENTMATCH", value: subQueryValueObj });
        break;
      }
      case "notOpen":
        queryObjs.push({
          field: "positions",
          condition: "ELEMENTMATCH",
          value: [
            {
              field: "position",
              value: searchValue.map((pos: IPosition) => pos.title),
              condition: "EQ",
            },
            {
              field: "crew_id",
              value: null,
              condition: "EQ",
            },
            {
              field: "openFlyingStatus",
              value: [OpenFlyingStatusType.OpenNonVisible, OpenFlyingStatusType.OpenVisible],
              condition: "NE",
            },
          ],
        });
        break;
      case "hasOpenFlyingSlotsNonVisible":
        queryObjs.push({
          field: "positions",
          condition: "ELEMENTMATCH",
          value: [
            {
              field: "position",
              value: searchValue.map((pos: IPosition) => pos.title),
              condition: "EQ",
            },
            {
              field: "crew_id",
              value: null,
              condition: "EQ",
            },
            {
              field: "openFlyingStatus",
              value: OpenFlyingStatusType.OpenNonVisible,
              condition: "EQ",
            },
          ],
        });
        break;
      case "hasOpenFlyingSlotsVisible":
        queryObjs.push({
          field: "positions",
          condition: "ELEMENTMATCH",
          value: [
            {
              field: "position",
              value: searchValue.map((pos: IPosition) => pos.title),
              condition: "EQ",
            },
            {
              field: "crew_id",
              value: null,
              condition: "EQ",
            },
            {
              field: "openFlyingStatus",
              value: OpenFlyingStatusType.OpenVisible,
              condition: "EQ",
            },
          ],
        });
        break;
      case "onCrewMember":
        queryObjs.push({
          field: "positions.crew_id",
          condition: "EQ",
          value: searchValue,
        });
        break;
      case "baseICAO":
        queryObjs.push({
          field: "baseICAO",
          condition: "EQ",
          value: searchValue,
        });
        break;
      case "foreignId":
        queryObjs.push({
          field: "foreignRef.foreignId",
          condition: "EQ",
          value: searchValue.map((foreignId: ISearchPairing) => foreignId),
        });
        break;
      case "batchId":
        queryObjs.push({
          field: "batchId",
          condition: "EQ",
          value: searchValue.map((batchId: ISearchPairing) => batchId),
        });
        break;
      case "createdBy":
      case "modifiedBy":
        queryObjs.push({
          field: fieldName,
          condition: "EQ",
          value: filter?.searchValue,
        });
        break;
      // default:
    }

    queryFilters.push(...queryObjs);

    return queryFilters;
  }, []);
  return {
    queryArgs: newFilters,
    returnFields: [
      // "shortId",
      // "_id",
      // "_old_id",
      // "baseICAO",
      // "foreignRef",
      // "positions",
      // "start",
      // "end",
      // "eventGroups",
      // "origin",
      // "destination",
      // "logicModifiers",
      // Temporal fields.
      // "batchId",
      // "createdBy",
      // "createdAt",
      // "modifiedBy",
      // "modifiedAt",
      // "shortDescription",
    ],
  };
};

// Reduce the filters array to an objects to simplify filtering the dataset.
export const reducedFilter = (selectedFilter: any, allowMultiFilter: boolean): any => {
  const reducedFilter = selectedFilter.reduce((map: any, filter: IFilterOption) => {
    const { value, searchValue } = filter;
    const key = value.replace("p_", "");
    switch (true) {
      case Array.isArray(searchValue) && searchValue.length > 0: // Array with Value
        map[key] = searchValue;
        break;
      case !!searchValue &&
        !Array.isArray(searchValue) &&
        searchValue.hasOwnProperty("minTime") &&
        searchValue.hasOwnProperty("maxTime"): // Date Range
        if (!!searchValue.minTime || !!searchValue.maxTime) {
          map[key] = searchValue;
        }
        break;
      case !!searchValue && !Array.isArray(searchValue): // Simple Value
        map[key] = searchValue;
        break;
      case !allowMultiFilter: // Used as single filter (almost makes value even when null)
        map[key] = searchValue;
        break;
      default:
        break;
    }
    return map;
  }, {});
  return reducedFilter;
};

/**
 * Accepts the user's input, the selected filter and the selected filter type and passes in the found flights
 * into an array and the first found flight into the callback function searchFlightByInput
 * which the callback function in the FlightTimeline.tsx will fire the jumpToInputtedFlight function
 * @param searchValue -
 * @param eventType - // used in the advanced filter search table
 */
export const filterEvents = (filters: any, events: ISearchPairing[], isFlight: boolean): ISearchPairing[] => {
  // Set default sets to their searched event list.
  let newFilteredEvents: ISearchPairing[] = events;

  // If there are no filters containing values, or no data to filter, return
  if (!filters || Object.keys(filters).length === 0 || newFilteredEvents.length === 0) {
    return [];
  }

  for (const key in filters) {
    const searchValue = filters[key];
    if (!key || !filters) {
      return [];
    }

    newFilteredEvents = newFilteredEvents.filter((item: ISearchPairing) => {
      // CONTENT
      const typedKey = key as keyof typeof item;
      switch (key) {
        case "flightNumber":
        case "positioningFlightNumber":
          return !!searchValue && Array.isArray(searchValue) && typeof item[typedKey] === "number"
            ? searchValue.includes(item[typedKey].toString())
            : false;
        case "batchId":
        case "foreignId":
          return !!searchValue && Array.isArray(searchValue) && typeof item[typedKey] === "string"
            ? searchValue.includes(item[typedKey].toString())
            : false;
        case "start":
        case "end":
        case "createdAt":
        case "modifiedAt": {
          const dateValue = new Date(item[key]);
          const { minTime, maxTime } = searchValue;
          if (minTime && maxTime) {
            return dateValue >= new Date(minTime) && dateValue <= new Date(maxTime);
          } else if (minTime && !maxTime) {
            return dateValue >= new Date(minTime);
          } else if (!minTime && maxTime) {
            return dateValue <= new Date(maxTime);
          }
          return false;
        }
        case "origin":
        case "destination":
          if (!!searchValue && Array.isArray(searchValue)) {
            const airportIdents = searchValue.map((option: IAirportOption) => option.ident);
            return airportIdents.includes(item[key]);
          }
          return false;
        case "baseICAO": {
          const baseICAOArray = searchValue?.map((option: IPairing) => option.baseICAO);
          return baseICAOArray?.includes(item[key]);
        }
        case "aircraftType": {
          const aircraftTypeArray = searchValue?.map((event: IFlightType) => event.title);
          return aircraftTypeArray?.includes(item[typedKey]._id);
        }
        case "flightType":
        case "eventType":
        case "logicModifierType":
        case "nonFlyingType":
        case "onCrewMember": {
          const typeArray = searchValue?.map((event: IFlightType) => event._id);
          return typeArray?.includes(item[typedKey]._id);
        }
        case "createdBy":
        case "modifiedBy": {
          const userIdArray = searchValue?.map((user: IUser) => user._id);
          return userIdArray?.includes(item[typedKey]);
        }
        default:
          return false;
      }
    });
  }
  // update parent component.
  return newFilteredEvents;
};

export const filterContent = (filters: any, items: ISearchPairing[]): ISearchPairing[] => {
  // Set default sets to their searched event list.
  let newFilteredEvents: ISearchPairing[] = items;
  // If there are no filters containing values, or no data to filter, return
  if (!filters || Object.keys(filters).length === 0 || newFilteredEvents.length === 0) {
    return [];
  }
  for (const key in filters) {
    // const searchValue = filters[key];
    if (!key || !filters) {
      return [];
    }
    newFilteredEvents = newFilteredEvents.filter((item: ISearchPairing) => {
      return true;
    });
  }
  return newFilteredEvents;
};
